import React, { useEffect, useState } from 'react';
import { FaEdit, FaTrash, FaDesktop } from 'react-icons/fa';
import { Product, ProductStatus } from 'src/model/Product';
import { Grade } from 'src/model/Grade';

interface ProductManagerUIProps {
  products: Product[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
  handleStock: (stock: Grade[]) => number;
}

export const ProductManagerUI: React.FC<ProductManagerUIProps> = ({
  products,
  handleEdit,
  handleDelete,
  handleStock,
}) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isDesktop) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center">
        <FaDesktop className="text-6xl text-gray-400 mb-4" />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Disponível apenas no computador
        </h2>
        <p className="text-gray-500 max-w-md">
          No momento, só é possível fazer a edição de um produto pelo
          computador. Por favor, acesse através de um dispositivo com tela
          maior.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 gap-4 w-full overflow-x-hidden p-2">
      {products.map(
        (product) =>
          product.status === ProductStatus.ACTIVE && (
            <div
              key={product.id}
              className="border border-gray-100 rounded-lg shadow-md bg-white relative w-full sm:w-auto"
            >
              <div className="h-32 md:h-40 bg-white flex items-center justify-center overflow-hidden">
                {product.imagens && product.imagens.length > 0 ? (
                  <img
                    src={product.imagens[0]}
                    alt={product.name}
                    className="md:p-0 p-1 h-full w-full object-contain transform transition-transform duration-300 group-hover:scale-110"
                  />
                ) : (
                  <div className="text-gray-400 text-sm">
                    Imagem indisponível
                  </div>
                )}
              </div>

              <div className="flex flex-col px-3 mt-2">
                <h2
                  className="text-lg font-semibold text-gray-800 leading-tight overflow-hidden"
                  style={{
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    overflow: 'hidden',
                  }}
                  title={product.name}
                >
                  {product.name}
                </h2>

                <p className="text-sm text-gray-500 mb-1">
                  Estoque:{' '}
                  <span className="text-red-500 font-semibold">
                    {handleStock(product.grade)}
                  </span>
                </p>

                {/* Botões de ação */}
                <div className="w-full flex justify-around items-center space-x-2 my-2">
                  <button
                    onClick={() => handleEdit(product.id)}
                    className="flex items-center text-md text-blue-500 hover:text-blue-600 transition-transform duration-300 transform hover:scale-105"
                  >
                    <FaEdit className="mr-1" /> Editar
                  </button>
                  <button
                    onClick={() => handleDelete(product.id)}
                    className="flex items-center text-md text-red-500 hover:text-red-600 transition-transform duration-300 transform hover:scale-105"
                  >
                    <FaTrash className="mr-1" /> Excluir
                  </button>
                </div>
              </div>
            </div>
          )
      )}
    </div>
  );
};
